module.exports = __webpack_public_path__ + "static/img/2884_phase_function_Paper_Points.777fa14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2884_phase_function_Paper_Points.png
// module id = iUDS
// module chunks = 0